import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { Button } from 'foundations-components/transitional/components/Button';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { PermissionActionContainer } from './PermissionAction';

// @ts-expect-error migrate upstream
import { getId } from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error migrate upstream
import { isNil } from 'dashboard-lib/private/js-util';
import DashboardFiltersButton from './dashboardFilters/DashboardFiltersButton';
import { track as dashboardTracker, EVENTS
// @ts-expect-error migrate upstream
} from 'dashboard-ui-components/tracking/DashboardUITracker';
// @ts-expect-error migrate upstream
import { getDashboardListUrl } from 'dashboard-components/lib/urlHelpers';
import QuickFilterErrorBoundaryMessage from './quickFilters/QuickFilterErrorBoundaryMessage';
import PinnedPropertiesContainer from './quickFilters/PinnedPropertiesContainer';
import { PinnedPropertyErrorBoundary } from './quickFilters/panel/PinnedPropertyErrorBoundary';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const openDashboardManager = () => {
  dashboardTracker(EVENTS.openDashboardList, {
    subscreen: 'dashboard'
  });
  window.location = getDashboardListUrl();
};
const DashboardListLink = () => /*#__PURE__*/_jsx(Button, {
  use: "link",
  onClick: openDashboardManager,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'dashboardSelector.manageDashboardsButton'
  })
});
const SubHeader = props => {
  const {
    dashboard = null
  } = props;
  if (isNil(dashboard)) {
    return null;
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "SUB_HEADER_LOADED",
    children: /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        justify: "between",
        children: [/*#__PURE__*/_jsxs(UIButtonWrapper, {
          children: [/*#__PURE__*/_jsx(PinnedPropertyErrorBoundary, {
            dashboardId: getId(dashboard),
            messageComponent: QuickFilterErrorBoundaryMessage,
            children: /*#__PURE__*/_jsx(PinnedPropertiesContainer, {
              dashboard: dashboard
            })
          }), /*#__PURE__*/_jsx(DashboardFiltersButton, {
            dashboard: dashboard
          })]
        }), /*#__PURE__*/_jsxs(UIButtonWrapper, {
          children: [/*#__PURE__*/_jsx(DashboardListLink, {}), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(PermissionActionContainer, {
              dashboard: dashboard
            })
          })]
        })]
      })
    })
  });
};
export default SubHeader;